import apicaller from "@/utils/apicaller";
import api from "../../main.api";

export default {
  getProfile(entityKey, entityId) {
    return apicaller.get(`${api.CDD.entity}/profile/${entityKey}`, {
      params: { entityId }
    });
  },
  getHistory(entityKey, params, entityId) {
    return apicaller.get(`${api.CDD.entity}/history/${entityKey}`, {
      params: { ...(params || {}), entityId }
    });
  },
  getTrend(entityKey, params, entityId) {
    return apicaller.get(`${api.CDD.entity}/trend/${entityKey}`, {
      params: { ...(params || {}), entityId }
    });
  },
  getLiveData(entityKey, entityId) {
    return apicaller.get(`${api.CDD.entity}/livedata/${entityKey}`, {
      params: { entityId }
    });
  },

  // Score change requests
  getScoreChangeRequests(entityType, entityKey) {
    return apicaller.get(`${api.CDD.scoreChange}/${entityType}/${entityKey}`);
  },
  createScoreChangeRequest(dto) {
    return apicaller.post(`${api.CDD.scoreChange}/request`, dto);
  },
  reviewScoreChangeRequest(requestId, dto) {
    return apicaller.post(`${api.CDD.scoreChange}/${requestId}/review`, dto);
  },
  cancelScoreChangeRequest(requestId) {
    return apicaller.post(`${api.CDD.scoreChange}/${requestId}/cancel`);
  },
};
